import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PAGE_TITLE } from 'src/app/constants/NextGenConstants';

@Injectable({
  providedIn: 'root',
})
export class CustomTitleService extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.title.setTitle(`${title} - ${PAGE_TITLE}`);
    } else {
      this.title.setTitle(PAGE_TITLE);
    }
  }
}
